import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { DealPreviewStyled } from '../DealPreviewStyled';
import { rem } from 'polished';

export const DealPreviewStyledDS = styled(DealPreviewStyled)`
    .deal-steps-flow {
        .step-container {
            .icon {
                &.ok {
                    padding: 0;
                    background: ${({ theme }) => theme.colors.secondary};
                    border: 3px solid ${({ theme }) => theme.colors.secondary};
                }

                &.none {
                    border: 1px solid ${({ theme }) => theme.colors.grey16};
                }
            }

            .text {
                color: ${({ theme }) => theme.colors.black};
                font-size: ${({ theme }) => theme.fontSizes.h6};
            }
        }

        ul {
            &.timeline {
                &::before {
                    display: none;
                }
            }
        }
    }

    .deal-expiration {
        background-color: ${({ theme }) => theme.colors.grey7};
        padding: ${rem(12)} 0 ${rem(8)} ${rem(40)};
    }

    .deal {
        border: none;

        .deal-content {
            border: 1px solid ${({ theme }) => theme.colors.milkshake};
            border-radius: ${rem(8)};

            .car-header {
                .price-and-date {
                    .price-container {
                        min-height: ${rem(28)};
                        .price {
                            text-align: right;
                            font-size: ${({ theme }) => theme.fontSizes.h5};
                            font-weight: ${({ theme }) => theme.fontWeights.textBold};
                        }
                    }
                    .date {
                        font-size: ${({ theme }) => theme.fontSizes.h6};
                        padding-right: 0;
                        display: flex;
                        align-items: center;

                        svg {
                            width: ${rem(22)};
                            height: ${rem(22)};

                            path {
                                stroke: ${({ theme }) => theme.colors.black};
                            }
                        }
                    }
                }

                .title {
                    h2 {
                        font-style: normal;
                        color: ${({ theme }) => theme.colors.black};
                        font-family: DSAutomobiles;
                        font-size: ${rem(32)};
                        text-transform: uppercase;
                        font-weight: ${({ theme }) => theme.fontWeights.textBold};
                    }
                    &-engineInfo {
                        color: ${({ theme }) => theme.colors.black};
                        font-size: ${({ theme }) => theme.fontSizes.h6};
                    }
                }
            }
            .date-clock-icon {
                top: ${rem(1)};
                margin-right: ${rem(5)};

                svg {
                    width: ${rem(12)};
                    height: ${rem(12)};
                }

                .icon-wrapper {
                    path:first-of-type {
                        fill: ${({ theme }) => theme.colors.primary};
                    }
                    path:last-of-type {
                        stroke: ${({ theme }) => theme.colors.primary};
                    }
                }
            }

            &__order-data {
                padding: ${rem(20)} ${rem(20)} 0 ${rem(20)};
                font-size: ${({ theme }) => theme.fontSizes.h6};

                @media (min-width: ${breakpoints.sm}px) {
                    padding: ${rem(30)} ${rem(30)} 0 ${rem(30)};
                }
            }
        }
        .buttons {
            border-radius: ${rem(8)};

            .buttons-box {
                padding: ${rem(30)};
            }

            button {
                .spinner {
                    top: ${rem(7)};
                }

                &.view-all-details {
                    border: 1px solid ${({ theme }) => theme.colors.black1};
                    text-decoration: unset;
                    color: ${({ theme }) => theme.colors.black1};
                    border-radius: ${rem(24)};
                    padding: ${rem(15)} ${rem(24)};
                    height: ${rem(48)};
                  
                    &:hover,
                    &:focus-visible {
                        color: ${({ theme }) => theme.colors.primary};
                        border-color: ${({ theme }) => theme.colors.primary};
                        background: ${({ theme }) => theme.colors.grey4};
                    }
                }

                &.remove-deal {
                    font-weight: ${({ theme }) => theme.fontWeights.textBold};
                    text-decoration: unset;

                    svg {
                        width: ${rem(18)};
                        height: ${rem(10)};

                        path {
                            fill: ${({ theme }) => theme.colors.black};
                        }
                    }
                  
                    &:hover,
                    &:focus-visible {
                        color: ${({ theme }) => theme.colors.primary};

                        svg {
                            path {
                                fill: ${({ theme }) => theme.colors.primary};
                            }
                        }
                    }
                }

                &.continue {
                    background: ${({ theme }) => theme.colors.black1} !important;
                    border-color: ${({ theme }) => theme.colors.black1} !important;
                    color: ${({ theme }) => theme.colors.white} !important;
                    border-radius: ${rem(24)};
                    padding: ${rem(15)} ${rem(24)} !important;
                    height: ${rem(48)};
                  
                    &:hover,
                    &:focus-visible {
                        background: ${({ theme }) => theme.colors.primary} !important;
                        border-color: ${({ theme }) => theme.colors.primary} !important;
                    }
                }
            }
        }
    }
  
    .Collapsible { 
        .Collapsible__contentInner {
            .finance-summary--grid {
                background: unset;
                    .finance-summary--col-1 span {
                       font-size: ${({ theme }) => theme.fontSizes.h5};
                        font-weight: bold;
                    }
                    .finance-summary--row-2 {
                        background: ${({ theme }) => theme.colors.white};
                        border: 1px solid ${({ theme }) => theme.colors.milkshake};
                        border-radius: ${rem(8)};
                        margin-top: 10px;
                    }
                    .finance-summary--col-3.bold-style,
                    .finance-summary--col-2.bold-style {
                        span {
                            font-size: ${({ theme }) => theme.fontSizes.h5};
                        }
                    }
                    span {
                        font-family: ${({ theme }) => theme.fonts.fontBase};
                        font-size: ${({ theme }) => theme.fontSizes.h6};
                        color: ${({ theme }) => theme.colors.black};
                    }
                    .finance-summary__legalTextWrapper {
                        background: ${({ theme }) => theme.colors.white};
                        line-height: ${rem(18)};
                        border: 1px solid ${({ theme }) => theme.colors.milkshake};
                        border-radius: ${rem(8)};
                    }
                }
            }
        }
    }

  .overlay {
      .dialog {
          border-radius: ${rem(8)};

          p {
              font-size: ${({ theme }) => theme.fontSizes.h6};
          }
      }
  }
`;
